import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from "react-router-dom";
import { useReveal } from "../hooks/useReveal";
import Hero from "../sections/Hero";
import Origin from "../sections/Origin";
import Features from "../sections/Features";
import Copilot from "../sections/Copilot";
import Security from "../sections/Security";
import Pricing, { HowItWorks } from "../sections/Pricing";
import Faq from "../sections/Faq";
import FinalCta from "../sections/FinalCta";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";

const MainWrapper = styled.div`
  width: 100%;
  overflow-x: hidden;
  background-color: var(--paper);
  color: var(--text-hi);
`;

const Home = () => {
  const revealRef = useReveal();
  const { hash } = useLocation();

  // The router neither resets the scroll nor follows hashes: land on the section asked for by
  // the header links of the other pages (/#tarif), or at the top
  useEffect(() => {
    const target = hash && document.querySelector(hash);
    if (target) target.scrollIntoView({ behavior: "instant" });
    else if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [hash]);

  return (
    <MainWrapper ref={revealRef}>
      <Header />
      <main>
        <Hero />
        <Origin />
        <Features />
        <Copilot />
        <Security />
        <HowItWorks />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </MainWrapper>
  );
};

export default Home;
